// extracted by mini-css-extract-plugin
module.exports = {"Dlight_Kenya_Data_Form_Field_Wrapper":"DlightKenyaDataDetail_Dlight_Kenya_Data_Form_Field_Wrapper__3nzcD"};